import request from '@/utils/axios.js'

export function submitInfo (data) {
  return request({
    url: '/qrcode/a/mobileAPI/site/submit',
    method: 'post',
    data: data
  })
}

export function getCode (detailId) {
  return request({
    url: `/qrcode/a/mobileAPI/site/getQrcodeById/${detailId}`,
    method: 'post'
  })
}

export function getHistory (data) {
  return request({
    url: '/qrcode/a/mobileAPI/site/list',
    method: 'post',
    data: data
  })
}

export function submitAuth (data) {
  return request({
    url: '/qrcode/a/mobileAPI/trace/site/submit',
    method: 'post',
    data: data
  })
}

export function getSiteInfo (detailId) {
  return request({
    url: '/qrcode/a/mobileAPI/trace/site/info',
    method: 'post',
    data: {
      detailId: detailId
    }
  })
}
